/**
 * order-flow.js
 * 
 * Place in: assets/order-flow.js
 * Load in your theme.liquid (before </body>):
 *   {{ 'order-flow.js' | asset_url | script_tag }}
 * 
 * OR only on order page — in customers/order.liquid:
 *   <script src="{{ 'order-flow.js' | asset_url }}" defer></script>
 */

(function () {
  "use strict";

  /* ─────────────────────────────────────────────
     1. CANCEL COUNTDOWN TIMER
     Shows live "X hours Y mins remaining" countdown
  ───────────────────────────────────────────── */
  function initCancelCountdown() {
    const meta = window.__orderMeta;
    if (!meta || !meta.showCancel) return;

    const el = document.getElementById("cancel-countdown");
    if (!el) return;

    const orderTime   = new Date(meta.createdAt).getTime();
    const deadline    = orderTime + (3 * 60 * 60 * 1000); // +3 hours

    function tick() {
      const remaining = deadline - Date.now();
      if (remaining <= 0) {
        // Window has expired — hide cancel block
        const cancelBlock = document.querySelector(".cancel-block");
        if (cancelBlock) cancelBlock.style.display = "none";
        return;
      }
      const h = Math.floor(remaining / 3600000);
      const m = Math.floor((remaining % 3600000) / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      el.textContent = `Time remaining to cancel: ${h}h ${m}m ${s}s`;
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ─────────────────────────────────────────────
     2. CANCEL ORDER
     Calls your backend proxy endpoint which then 
     hits the Shopify Admin API.
     
     Backend endpoint: POST /apps/proxy/cancel-order
     (see cancel-order-backend.js for the Node endpoint)
  ───────────────────────────────────────────── */
  window.cancelOrder = async function (btn) {
    const meta = window.__orderMeta;
    if (!meta) return;

    const confirmed = window.confirm(
      "Are you sure you want to cancel this order? This cannot be undone."
    );
    if (!confirmed) return;

    btn.disabled  = true;
    btn.textContent = "Cancelling…";

    const feedback = document.getElementById("cancel-feedback");

    try {
      const res = await fetch("/apps/proxy/cancel-order", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orderId:   meta.orderId,
          orderName: meta.orderName
        })
      });

      const data = await res.json();

      if (res.ok && data.success) {
        showFeedback(feedback, "success", "✓ Your order has been cancelled. You'll receive a confirmation shortly.");
        btn.style.display = "none";
        // Optionally reload after 2s to refresh status
        setTimeout(() => window.location.reload(), 2500);
      } else {
        throw new Error(data.message || "Cancel failed");
      }
    } catch (err) {
      btn.disabled    = false;
      btn.textContent = "Cancel Order";
      showFeedback(feedback, "error", "Could not cancel order: " + err.message + ". Please contact support.");
    }
  };

  /* ─────────────────────────────────────────────
     3. RETURN FORM — File select handler
  ───────────────────────────────────────────── */
  window.handleFileSelect = function (input) {
    const file        = input.files[0];
    const placeholder = document.getElementById("upload-placeholder");
    const preview     = document.getElementById("upload-preview");
    if (!file) return;

    // Validate size (200MB max)
    const maxBytes = 200 * 1024 * 1024;
    if (file.size > maxBytes) {
      alert("Video must be under 200MB.");
      input.value = "";
      return;
    }

    placeholder.style.display = "none";
    preview.style.display     = "block";
    preview.innerHTML = `
      <span class="file-icon">🎥</span>
      <div class="file-info">
        <strong>${file.name}</strong>
        <small>${(file.size / (1024 * 1024)).toFixed(1)} MB</small>
      </div>
      <button type="button" class="file-remove" onclick="removeVideo()">Remove</button>
    `;
  };

  window.removeVideo = function () {
    document.getElementById("unboxing-video").value = "";
    document.getElementById("upload-placeholder").style.display = "flex";
    document.getElementById("upload-preview").style.display     = "none";
  };

  /* ─────────────────────────────────────────────
     4. SUBMIT RETURN REQUEST
     
     Flow:
     a) Upload video to your server (which stores to Cloudinary / S3 / Shopify Files)
     b) POST return request with video URL to your backend
     c) Backend creates draft return + adds order note + notifies team
  ───────────────────────────────────────────── */
  window.submitReturn = async function (orderId, orderName) {
    const reason      = document.getElementById("return-reason").value;
    const description = document.getElementById("return-description").value;
    const videoInput  = document.getElementById("unboxing-video");
    const feedback    = document.getElementById("return-feedback");
    const submitBtn   = document.querySelector("#return-form-modal .btn--submit");

    // Validate
    if (!reason) {
      showFeedback(feedback, "error", "Please select a return reason.");
      return;
    }
    if (!videoInput.files[0]) {
      showFeedback(feedback, "error", "An unboxing video is required to process your return.");
      return;
    }

    submitBtn.disabled    = true;
    submitBtn.textContent = "Uploading video…";
    showFeedback(feedback, "info", "Uploading your video, please wait…");

    try {
      // ── Step 1: Upload video ──
      const formData = new FormData();
      formData.append("video", videoInput.files[0]);
      formData.append("orderId", orderId);
      formData.append("orderName", orderName);

      const uploadRes  = await fetch("/apps/proxy/upload-return-video", {
        method: "POST",
        body:   formData
      });
      const uploadData = await uploadRes.json();
      if (!uploadRes.ok) throw new Error(uploadData.message || "Upload failed");

      const videoUrl = uploadData.url; // returned from your backend

      // ── Step 2: Submit return request ──
      submitBtn.textContent = "Submitting return…";

      const returnRes = await fetch("/apps/proxy/submit-return", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          orderId,
          orderName,
          reason,
          description,
          videoUrl
        })
      });
      const returnData = await returnRes.json();
      if (!returnRes.ok) throw new Error(returnData.message || "Return submission failed");

      // ── Success ──
      showFeedback(feedback, "success",
        "✓ Return request submitted! You'll receive a WhatsApp confirmation with next steps within 24 hours."
      );
      submitBtn.style.display = "none";

    } catch (err) {
      submitBtn.disabled    = false;
      submitBtn.textContent = "Submit Return Request";
      showFeedback(feedback, "error", "Error: " + err.message);
    }
  };

  /* ─────────────────────────────────────────────
     HELPER
  ───────────────────────────────────────────── */
  function showFeedback(el, type, msg) {
    if (!el) return;
    el.style.display    = "block";
    el.className        = "action-feedback feedback--" + type;
    el.textContent      = msg;
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  document.addEventListener("DOMContentLoaded", function () {
    initCancelCountdown();

    // Close modal on overlay click
    const modal = document.getElementById("return-form-modal");
    if (modal) {
      modal.addEventListener("click", function (e) {
        if (e.target === modal) modal.style.display = "none";
      });
    }

    // Drag-and-drop for video upload
    const dropArea = document.getElementById("upload-drop-area");
    if (dropArea) {
      dropArea.addEventListener("dragover",  e => { e.preventDefault(); dropArea.classList.add("drag-over"); });
      dropArea.addEventListener("dragleave", ()  => dropArea.classList.remove("drag-over"));
      dropArea.addEventListener("drop", e => {
        e.preventDefault();
        dropArea.classList.remove("drag-over");
        const input = document.getElementById("unboxing-video");
        input.files = e.dataTransfer.files;
        handleFileSelect(input);
      });
    }
  });

})();
